import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Customers from './pages/Customers';
import PackagesPromos from './pages/PackagesPromos';
import BranchManager from './pages/BranchManager';
import StaffManager from './pages/StaffManager';
import VehicleManager from './pages/VehicleManager';
import Scheduling from './pages/Scheduling';
import Settings from './pages/Settings';
import KPIConfiguration from './pages/KPIConfiguration';
import UserManager from './pages/UserManager';
import { OpsProvider, useOps } from './context/OpsContext';
import AppLoader from './components/AppLoader';
import './App.css';

const AppContent = ({ isSidebarOpen, setIsSidebarOpen, isDesktop }) => {
  const { loading } = useOps();
  return (
    <>
      <AppLoader appName="Operations Manager" loading={loading} />
      <div className="app-container">
        {isSidebarOpen && !isDesktop && (
          <div className="mobile-overlay" onClick={() => setIsSidebarOpen(false)} />
        )}
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} isDesktop={isDesktop} />
        <div className="main-content" style={{ marginLeft: isDesktop ? 'var(--sidebar-width)' : 0 }}>
          <Header setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />
          <div className="page-content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/packages" element={<PackagesPromos />} />
              <Route path="/branches" element={<BranchManager />} />
              <Route path="/staff" element={<StaffManager />} />
              <Route path="/instructors" element={<StaffManager isInstructorMode={true} />} />
              <Route path="/vehicles" element={<VehicleManager />} />
              <Route path="/scheduling" element={<Scheduling />} />
              <Route path="/kpis" element={<KPIConfiguration />} />
              <Route path="/users" element={<UserManager />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<div>Page Not Found</div>} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <OpsProvider>
      <Router>
        <AppContent isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />
      </Router>
    </OpsProvider>
  );
}

export default App;
